import { IdentifierDTO } from '@zazume/zzm-base';
import { doGet, doPost, doPut, parserDataList } from '../../helpers';
import { KeyDelivery, RelatedModelType } from '#/models/keyDelivery/KeyDelivery';
import { UpdateFromRequest } from './models/UpdateFromRequest';
import { CreateRequest } from './models/CreateRequest';
import { UpdateToRequest } from './models/UpdateToRequest';
import { KeyHandoverCreateRequest } from './models/KeyHandoverCreateRequest';
import { KeyDelivery as KeyDeliveryDomain } from '#/domain/keyDelivery/KeyDelivery';

export const keyDelivery = {
  getById: (id: IdentifierDTO) => () =>
    doGet<KeyDelivery>(`/dashboard/key-delivery/${id}`),
  getByUnitId: (unitId: IdentifierDTO) => () =>
    doGet<KeyDeliveryDomain[]>(`/dashboard/key-delivery/unit/${unitId}`, parserDataList(KeyDeliveryDomain.fromRaw)),
  create: (relatedModelId: IdentifierDTO, relatedModelType: RelatedModelType) =>
    (request: CreateRequest) =>
      doPost<KeyDelivery>(`/dashboard/key-delivery/${relatedModelType}/${relatedModelId}`, request),
  createFromUnit: (unitId: IdentifierDTO) => (request: KeyHandoverCreateRequest) =>
    doPost<KeyDelivery>(`/dashboard/key-delivery/unit/${unitId}`, request.toBody()),
  updateFrom: (keyDeliveryId: IdentifierDTO) =>
    (request: UpdateFromRequest) =>
      doPut<KeyDelivery>(`/dashboard/key-delivery/from/${keyDeliveryId}`, request),
  updateTo: (keyDeliveryId: IdentifierDTO) =>
    (request: UpdateToRequest) =>
      doPut<KeyDelivery>(`/dashboard/key-delivery/to/${keyDeliveryId}`, request),
  cancel: (id: IdentifierDTO) => () =>
    doPut<void>(`/dashboard/key-delivery/cancel/${id}`),
  setAsDelivered: (id: IdentifierDTO) => () =>
    doPut<void>(`/dashboard/key-delivery/${id}/delivered`),
  setAsNotDelivered: (id: IdentifierDTO) => () =>
    doPut<void>(`/dashboard/key-delivery/${id}/not-delivered`)
};
